<template>
	<div class="col-12 px-0">Redirecionando...</div>
</template>

<script>
	import Swal from 'sweetalert2'
	import { mapGetters } from 'vuex'

	export default {
		name: 'CallPanel',
		data() {
			return {
				bridge_key: null,
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
		},
		methods: {
			RedirectToPanel() {
				return window.api
					.call('post', '/redirect-to-panel', {
						organization_id: this.requester_selected_id,
					})
					.then(({ data }) => {
						if (!data.response) {
							Swal.fire({
								icon: 'error',
								title: 'Erro!',
								text:
									data.message ??
									'Erro ao redirecionar para o painel!',
							})

							return
						}

						this.bridge_key = data.bridge_key

						const url = `${process.env.VUE_APP_PANEL_URL}/auth/${this.bridge_key}`

						window.open(url, '_blank', 'noopener')

						this.$router.push({
							name: 'Home',
						})
					})
			},
		},
		beforeMount() {
			this.RedirectToPanel()
		},
	}
</script>

<style></style>
